import Container from 'common/components/container.component';
import Pulsate from 'common/components/pulsate.component';
import { DeviceTypeList } from 'config/constants/global.constants';
import { useDeviceType } from 'config/hooks/useDeviceType.hook';
import React from 'react';
import styles from './style.module.scss';

const CartItemSkeleton: React.FC = () => (
  <div className={styles['cart-item-skeleton']}>
    <div className={styles['cart-item-left']}>
      <Pulsate width='64px' height='64px' />
      <div className={styles['cart-item-info']}>
        <Pulsate width='220px' height='20px' marginBottom='8px' />
        <Pulsate width='150px' height='14px' marginBottom='6px' />
        <Pulsate width='100px' height='14px' />
      </div>
    </div>

    <div className={styles['cart-item-right']}>
      <Pulsate width='120px' height='40px' />
    </div>
  </div>
);

const CartSkeleton: React.FC = () => {
  const deviceType = useDeviceType();

  const renderItemsList = (count: number): React.ReactNode[] => {
    const items: React.ReactNode[] = [];
    for (let index = 0; index < count; index++) {
      items.push(<CartItemSkeleton key={index} />);
    }
    return items;
  };

  const isDesktop = deviceType === DeviceTypeList.DESKTOP;

  return (
    <Container>
      <div className={styles['cart-container-skeleton']}>
        <div className={styles['cart-list-wrapper']}>{renderItemsList(isDesktop ? 5 : 4)}</div>
      </div>
    </Container>
  );
};

export default CartSkeleton;
